// import { homeHeroSlider } from './homeHeroSlider';
import { testimonialSlider } from './testimonialSlider';

export default function initSliders() {
  // homeHeroSlider();
  testimonialSlider();
}
